import { useId } from 'react';
import type { SVGProps } from 'react';

const EffortlessPayment = ({ style, ...props }: SVGProps<SVGSVGElement>) => {
  const gradientId = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      style={style}
      {...props}
    >
      <rect x="0.556" y="0.556" width="38.889" height="38.889" rx="8.333" fill="white" />
      <rect
        x="0.556"
        y="0.556"
        width="38.889"
        height="38.889"
        rx="8.333"
        stroke={`url(#${gradientId})`}
        strokeWidth="1.111"
      />
      <path
        d="M10.74 18.148H29.259M12.592 13.519H27.407C28.43 13.519 29.259 14.348 29.259 15.37V24.63C29.259 25.652 28.43 26.482 27.407 26.482H12.592C11.569 26.482 10.74 25.652 10.74 24.63V15.37C10.74 14.348 11.569 13.519 12.592 13.519Z"
        stroke="currentColor"
        strokeWidth="1.111"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="40"
          y1="16.936"
          x2="0"
          y2="16.589"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5F59FF" />
          <stop offset="1" stopColor="#FF7749" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default EffortlessPayment;
